import React, { useState } from "react"
import Modal from 'react-bootstrap/Modal';
import MapComponent from '../utilsComponent/mapComponent';

const PolygonView = (props) => {
  const [showPolygon, setShowPolygon] = useState(false)

  return (
    <div>
       <h3 onClick={() => setShowPolygon(true)} className="request1GIS">View Polygon</h3>
       <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={showPolygon}
            onHide={() => {setShowPolygon(false)}}
            backdrop="static"
        >
            <Modal.Header closeButton>
                <Modal.Title className="h5 text-primary border-0 pb-0" id="contained-modal-title-vcenter">
                    Polygon Map
                </Modal.Title>
            </Modal.Header>
        <Modal.Body>
                <MapComponent polygonData={props.polygonData}/>
            </Modal.Body>
        </Modal>
   </div>
  )
};

export default PolygonView;